import axios, { testR } from "./common.js";
import { Message } from "element-ui";
const request = axios.create({
  timeout: 30000
});
// 请求拦截器
request.interceptors.request.use(
  config => {
    console.log("请求拦截器", config);
    return config; // 返回这个配置对象，如果没有返回，这个请求就不会发送出去
  },
  error => {
    return Promise.reject(error);
  }
);

//新建商品
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/chain/basegoods/generate
export const basegoodsGenerate = function (data) {
  return axios
    .post(
      "v3/merchant/chain/basegoods/generate",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        item: { ...data },
        mch_no: localStorage.getItem("merchant_id")
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

//查询商品
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/chain/basegoods/query
export const getBasegoodsInfo = function (barcode, accuracy) {
  return axios
    .post(
      "v3/merchant/chain/basegoods/query",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        barcode,
        accuracy,
        mch_no: localStorage.getItem("merchant_id")
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

//修改商品信息
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/chain/basegoods/modify
export const basegoodsModify = function (data) {
  return axios
    .post(
      "v3/merchant/chain/basegoods/modify",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        item: { ...data },
        service_no: localStorage.getItem("service_no")
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

//TODO: 不用这个接口了
//获取全部类别
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/chain/classify/list
export const getClassifyList = function () {
  return axios
    .post(
      "v3/ePlatform/Service/Merchant/chain/classify/list",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type")
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

//创建单据
/**
 * 新建交易单据
 * @param {} header
 * @param {*} detail
 * @param {*} sheet_type PI 进货入库单 RO 退货出库单 SO 销售单
 * @returns
 */
export const sheetGenerate = function (header, detail, sheet_type, branch_flag) {
  const data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    ...header,
    oper_no: "1001",
    detail,
    sheet_type,
    mch_no: localStorage.getItem("merchant_id"),
    branch_flag,
    merchant_id: localStorage.getItem("merhcnat_id")
  };
  console.log("data-----", JSON.stringify(data));
  return axios
    .post("v3/merchant/chain/Transcation/sheet/generate", JSON.stringify(data))
    .catch(err => {
      Message.error(err);
    });
};

//搜索单据
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant//chain/Transcation/sheet/query
export const sheetQuery = function (sheet_no) {
  return axios
    .post(
      "v3/merchant/chain/Transcation/sheet/query",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        sheet_no,
        mch_no: localStorage.getItem("merchant_id"),
        merchant_id: localStorage.getItem("merhcnat_id")
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

//检索单据
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant//chain/Transcation/sheet/list
export const getSheetList = function (sheet_type) {
  return new Promise((resolve, reject) => {
    var data = {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      sheet_type,
      start_time: "2024-05-01",
      expire_time: "2099-12-30",
      mch_no: localStorage.getItem("merchant_id"),
      merchant_id: localStorage.getItem("merhcant_id")
    };
    axios
      .post(
        "v3/merchant/chain/Transcation/sheet/list",
        JSON.stringify(data)
      )
      .then(res => {
        if (testR(res)) {
          var list = res.data.resp_data.filter(item => item);
          resolve(list);
        }
      })
      .catch(err => {
        Message.error(err);
      });
  });
};

/**
 * 批量查询商品信息
 * @param {*} list
 * @returns
 */
export const basegoodsBatchquery = function (list) {
  return axios
    .post(
      "v3/merchant/chain/basegoods/BatchQuery",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        merchant_id: localStorage.getItem("merchant_id"),
        token_type: localStorage.getItem("token_type"),
        items: list
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

//修改单据
///v3/merchant/chain/Transcation/sheet/modify
export const sheetModify = function (header, detail, sheet_no) {
  return axios
    .post(
      "v3/merchant/chain/Transcation/sheet/modify",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        mch_no: localStorage.getItem("merhcant_id"),
        merchant_id: localStorage.getItem("merhcnat_id"),
        ...header,
        detail,
        sheet_no
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

//删除单据
//v3/merchant/chain/Transcation/sheet/delete
export const sheetDelete = function (sheet_no) {
  return axios
    .post(
      "v3/merchant/chain/Transcation/sheet/delete",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        merchant_id: localStorage.getItem("merchant_id"),
        sheet_no,
        mch_no: localStorage.getItem("merchant_id")
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

//生成进货入库单

//审核单据
//v3/merchant/chain/Transcation/sheet/approve
export const sheetApprove = function (sheet_no) {
  return axios
    .post(
      "v3/merchant/chain/Transcation/sheet/approve",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        merchant_id: localStorage.getItem("merchant_id"),
        sheet_no,
        mch_no: localStorage.getItem("merchant_id")
      })
    )
    .catch(err => {
      Message.error(err);
    });
};
//反审核单据
//v3/merchant/chain/Transcation/sheet/approve
export const sheetUnApprove = function (sheet_no) {
  return axios
    .post(
      "v3/merchant/chain/Transcation/sheet/unapprove",
      JSON.stringify({
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        merchant_id: localStorage.getItem("merchant_id"),
        sheet_no,
        mch_no: localStorage.getItem("merchant_id")
      })
    )
    .catch(err => {
      Message.error(err);
    });
};

/* /v3/merchant/chain/Transcation/sheet/LastTranscationPrice */

/**
 * 上次的价格
 * @param {String[]} detail 条码数组
 * @param {string} other_mch_no 对方店铺号
 * @returns
 */
export const sheetLastTranscationPrice = function (detail, other_mch_no) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    other_mch_no,
    detail,
    mch_no: localStorage.getItem("merchant_id")
  };
  // console.log("json格式的数据", JSON.stringify(data));
  return axios.post(
    "v3/merchant/chain/Transcation/sheet/LastTranscationPrice",
    JSON.stringify(data)
  );
};
